/*
 * ---------------------------------------------------------------------
 * System Action Types
 * ---------------------------------------------------------------------
 */
export const SET_APPOINTMENT_LIST = "SET_APPOINTMENT_LIST";
export const SET_APPOINTMENT_IDENTIFIER = "SET_APPOINTMENT_IDENTIFIER";
